export default __webpack_public_path__ + "static/dump-truck-ud-trucks-4d407ff83868699ab72b0b35a5fb819a.png";